import MainSlogan from './slogan.svg'

const Slogan = ({ className }) => {
  return (
    <img src={MainSlogan} className={className} alt="A.N.K. Tours - zuverlässig und bequem" />
  )
}

export default Slogan